import { Badge } from "@merge-api/merge-javascript-shared";
import { displayPlanMode } from "../helpers";
import { BLUEPRINT_GLYPH, PLAN_GLYPH } from "../constants";

export const EnabledBadge = ({ enabled }: { enabled: boolean }) => (
  <Badge color={enabled ? "green" : "gray"}>{enabled ? "Enabled" : "Disabled"}</Badge>
);

export const ModeBadge = ({ mode }: { mode: string }) => {
  const label = displayPlanMode(mode);
  return <Badge color={label === "RUN_ALL" ? "blue" : "purple"}>{label}</Badge>;
};

// Square "BP" / "PL" glyph distinguishing blueprint steps from nested-plan steps.
export const KindGlyph = ({ isNestedPlan }: { isNestedPlan: boolean }) => (
  <span
    className="inline-flex h-5 w-5 shrink-0 items-center justify-center rounded font-mono text-[10px] font-bold leading-none"
    style={isNestedPlan ? PLAN_GLYPH : BLUEPRINT_GLYPH}
  >
    {isNestedPlan ? "PL" : "BP"}
  </span>
);

// Badge naming a step's kind explicitly (blueprint step vs nested plan).
export const KindBadge = ({ isNestedPlan }: { isNestedPlan: boolean }) => (
  <Badge color={isNestedPlan ? "purple" : "blue"}>{isNestedPlan ? "Plan" : "Blueprint"}</Badge>
);

// Show the window sync setting for every blueprint step.
export const WindowSyncBadge = ({ enabled }: { enabled: boolean }) => (
  <Badge color={enabled ? "orange" : "gray"}>{enabled ? "Window sync" : "Not window sync"}</Badge>
);
